
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class CheckboxRenderer extends Vue {
  @Prop() item!: any;
}
